module.exports = __webpack_public_path__ + "static/calm.4a24315d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/covers/calm.png
// module id = 332
// module chunks = 73016943110679